import { render, staticRenderFns } from "./resSucc.vue?vue&type=template&id=79a19b05&scoped=true&"
import script from "./resSucc.vue?vue&type=script&lang=js&"
export * from "./resSucc.vue?vue&type=script&lang=js&"
import style0 from "./resSucc.vue?vue&type=style&index=0&id=79a19b05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a19b05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a19b05')) {
      api.createRecord('79a19b05', component.options)
    } else {
      api.reload('79a19b05', component.options)
    }
    module.hot.accept("./resSucc.vue?vue&type=template&id=79a19b05&scoped=true&", function () {
      api.rerender('79a19b05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/register/resident/resSucc.vue"
export default component.exports